// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"490":"8769990a","575":"3ba342b2","725":"9deb8b47","805":"4abc4cd4"}[chunkId] + ".chunk.js";
};